/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, object } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: `${theme.spacing(3)}px 0px`,
        borderBottomStyle: 'dotted',
        borderWidth: 1,
    },
    [theme.breakpoints.down(theme.breakpoints.minWidth.small_screen_up)]: {
        skuLabelAmount: {
            textAlign: 'center',
        },

    },
    skuLabelAmount: {
        '& .retail': {
            textDecoration: 'line-through',
        },
        '& .sale': {
            color: theme.palette.pdp?.salePrice,
        },
    },
}));

const SingleVariantPrice = ({ sku, className }) => {
    const classes = useStyles();
    const retailPrice = sku?.prices?.[0]?.value || null;
    const salePrice = sku?.prices?.[1]?.value || null;

    if (retailPrice && salePrice && salePrice < retailPrice) {
        return (
            <div>
                <span className={`${classes.skuLabelAmount} ${className}`}>
                    <span className="sale">${salePrice}</span>
                    {' '}
                    <span className="retail">${retailPrice}</span>
                </span>
            </div>
        );
    }

    return (
        <div>
            <span className={`${classes.skuLabelAmount} ${className}`}>${retailPrice}</span>
        </div>
    );
};

SingleVariantPrice.propTypes = {
    sku: string.isRequired,
    className: object,
};

SingleVariantPrice.defaultProps = {
    className: {},
};

export default SingleVariantPrice;
